import Cookies from 'js-cookie';
class ContrastManager {
    contrastCookieKey = 'contrastIsActive';
    switch() {
        const contrastIsActive = Cookies.get(this.contrastCookieKey);
        if (contrastIsActive === undefined) {
            Cookies.set(this.contrastCookieKey, 'true', { expires: 365 });
        }
        else {
            Cookies.remove(this.contrastCookieKey);
        }
        window.location.reload();
    }
}
const contrastManager = new ContrastManager();
window.contrastManager = contrastManager;
export { contrastManager };
